import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Désactive la restauration auto du navigateur et scrolle en haut à chaque
// changement d'URL (et au premier chargement).
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
